import { useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LanguageContext } from '../contexts/LanguageContext';
import url from '../constants/urlsPaths';
import './UserInfo.css';
import Preferences from '../generics/Preferences';
import Axios from 'axios';
import jspdf from "jspdf";
import html2canvas from 'html2canvas';

// Dynamically import PageCharts
function getPageChartsComponent() {
  return { PageCharts: require('../generics/PageCharts').default };
}

const normalizeDuration = (duration) => {
  if (duration == null || duration === "null" || duration === "undefined") {
    return "null";
  }

  let current = duration;

  for (let i = 0; i < 3; i++) {
    if (typeof current !== 'string') break;

    const trimmed = current.trim();
    if (!trimmed || trimmed === "null" || trimmed === "undefined") {
      return "null";
    }

    try {
      current = JSON.parse(trimmed);
      continue;
    } catch (error) {
      return duration;
    }
  }

  if (typeof current === 'object' && current !== null && 'hours' in current) {
    return current;
  }

  return duration;
};

const waitForPdfRender = async (timeoutMs = 5000) => {
  const startTime = Date.now();

  while (Date.now() - startTime < timeoutMs) {
    const pages = Array.from(document.getElementsByClassName("PageCharts-chart"));
    const firstPageText = pages[0]?.textContent || "";

    if (pages.length > 0 && !/undefinedh|undefinedm|undefineds/i.test(firstPageText)) {
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      return true;
    }

    await new Promise(resolve => setTimeout(resolve, 100));
  }

  return false;
};

const normalizePdfLanguage = (language) => {
  if (!language || typeof language !== 'string') return 'en';
  const normalized = language.trim().toLowerCase();
  if (!normalized) return 'en';
  return normalized.slice(0, 2);
};

const getSessionLanguage = () => {
  try {
    const value = sessionStorage.getItem('language');
    return normalizePdfLanguage(value);
  } catch (error) {
    return null;
  }
};

// PDF generation and sending logic

const PDFLogic = async (userCode, email, language, action = "download", auth) => {
  const pdfBtnLoader = document.getElementById("loader");
  const pdfBtntext = document.getElementById("pdf-btn-text");
  if (pdfBtnLoader) pdfBtnLoader.style.display = "block";
  if (pdfBtntext) pdfBtntext.style.display = "none";

  // Add class to hide recharts tooltips
  document.body.classList.add("hide-tooltips-for-pdf");

  let doc = new jspdf('p', 'pt', [842, 595]);
  const pages = document.getElementsByClassName("PageCharts-chart");
  let scale = 1.66;
  for (let i = 0; i < pages.length; i++) {
    await new Promise(resolve => {
      html2canvas(pages[i], { scale }).then(canvas => {
        const img = canvas.toDataURL("image/jpeg", 0.8);
        doc.addImage(img, 'JPEG', 0, 0, 595, 842);
        if (i + 1 === pages.length) {
          if (action === "download" || action === "downloadAndSend" || action === "downloadAndStore" || action === "downloadAndSendAndStore") {
            doc.save(`Scope-Report-${userCode}.pdf`, { compress: true });
          }
          if (action === "sendToServer" || action === "downloadAndStore" || action === "sendAndStore" || action === "downloadAndSendAndStore") {
            console.log("sendToServer PDF");
            const blob = doc.output('blob');
            const formData = new FormData();
            formData.append('pdf', blob, `Scope-Report-${userCode}.pdf`);
            formData.append('code', userCode);
            formData.append('email', email);
            formData.append('language', language);
            console.log("Sending PDF to server for user code:", userCode, url.storePdfOnServer);

            Axios.post(url.storePdfOnServer, formData, {
              headers: {
                "x-access-token": (() => {
                  if (!auth || auth === "null" || auth === "undefined") return null;
                  try { return auth; } catch { return null; }
                })()
              }
            })
              .then(res => {
                //alert(res.data.success ? "PDF stored on server!" : "Failed to store PDF.");
                console.log(res.data.success ? "PDF stored on server!" : "Failed to store PDF.");
              })
              .catch((err) => {
                console.error("an Error storing PDF:", err.response || err);
                alert("Failed to store PDF.");
              });
          }
          if ((action === "send" || action === "downloadAndSend" || action === "sendAndStore" || action === "downloadAndSendAndStore") && email) {
            const blob = doc.output('blob');
            const formData = new FormData();
            formData.append('pdf', blob, `Scope-Report-${userCode}.pdf`);
            formData.append('email', email);
            formData.append('language', language);
            Axios.post(url.sendEmailPdf, formData, {
              headers: {
                "x-access-token": (() => {
                  const token = sessionStorage.getItem("token");
                  if (!token || token === "null" || token === "undefined") return null;
                  try { return JSON.parse(token); } catch { return null; }
                })()
              }
            })
              .then(res => {
                alert(res.data.success ? "Email sent!" : "Failed to send email.");
              })
              .catch(() => {
                alert("Failed to send email.");
              });
          }
        } else {
          doc.addPage();
        }
        resolve();
      });
    });
  }

  // Remove the class after PDF generation
  setTimeout(() => {
    document.body.classList.remove("hide-tooltips-for-pdf");
    if (pdfBtnLoader) pdfBtnLoader.style.display = "none";
    if (pdfBtntext) pdfBtntext.style.display = "block";
  }, 3000);
  return true;
};

export default function ScopePDFReport() {
  const { testRef, auth } = useParams();
  // If the page is opened with an auth param, store it in sessionStorage
  // so the top-level App can detect the authenticated state.
  useEffect(() => {
    if (auth) {
      const existing = sessionStorage.getItem('token');
      if (!existing || existing === 'null' || existing === 'undefined') {
        try {
          sessionStorage.setItem('token', JSON.stringify(auth));
          sessionStorage.setItem('auth', JSON.stringify(auth));
        } catch (e) {
          console.warn('Failed to persist auth token in sessionStorage', e);
        }
        // Reload so App.useToken picks up the new token and renders protected routes
        window.location.reload();
      }
    }
  }, [auth]);
  const { locale } = useContext(LanguageContext);
  const [showPopup, setShowPopup] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
const checkPdfExists = async (userKey, auth, language) => {
  try {
    const pdfLanguage = normalizePdfLanguage(language);
    const res = await Axios.get(
      url.checkPdfExists + `?key=${encodeURIComponent(userKey)}&language=${encodeURIComponent(pdfLanguage)}`,
      {
        headers: {
          "x-access-token": (() => {
            if (!auth || auth === "null" || auth === "undefined") return null;
            try { return auth; } catch { return null; }
          })()
        }
      }
    );
    return res.data.exists; // backend should return { exists: true/false }
  } catch (err) {
    console.error("Error checking PDF existence:", err);
    return false;
  }
};

  useEffect(() => {
    const ensurePdfOnServer = async () => {
      if (loading || !userData) return;

      const currentPdfLanguage = normalizePdfLanguage(getSessionLanguage() || locale || userData?.language);

      const exists = await checkPdfExists(userData.key, auth, currentPdfLanguage);

      if (exists) {
        console.log("PDF already exists on server for user:", userData.key);
        return;
      }

      await waitForPdfRender();
      await PDFLogic(userData.key, email, currentPdfLanguage, "sendToServer", auth);
    };

    ensurePdfOnServer();
  }, [loading, userData, auth, locale, email]);
 
  useEffect(() => {
    Axios.post(url.oneLicence, { key: testRef }, {
      headers: {
        "x-access-token": (() => {
          if (!auth || auth === "null" || auth === "undefined") return null;
          try { return auth; } catch { return null; }
        })()
      }
    })
      .then(res => {
        if (res.data && res.data.user) {
          const normalizedUser = {
            ...res.data.user,
            testDuration: normalizeDuration(res.data.user.testDuration)
          };
          setUserData(normalizedUser);
          setEmail(normalizedUser.email || "");
        } else {
          window.location.href = "/key/intro";
        }
        setLoading(false);
      })
      .catch(() => {
        setUserData(null);
        setLoading(false);
      });
  }, [testRef, auth]);


  if (loading) return <div>Loading...</div>;
  if (!userData) return <div>User not found for code: {testRef}</div>;

  const PageChartsComponents = getPageChartsComponent();
  const effectiveLocale = PageChartsComponents.forceLocale || locale;
  const pdfLanguage = normalizePdfLanguage(getSessionLanguage() || effectiveLocale || userData.language);

  const handleDownloadClick = () => setShowPopup(true);

  return (
    <div id="UserInfo" className={window.location.pathname.endsWith('/translate') ? "user-info-inline" : ""}>
      <div onClick={handleDownloadClick} className="download-pdf-btn">
        <div id="loader" className="loader-btn">
          <div className="loader">
            <div className="inner one"></div>
            <div className="inner two"></div>
            <div className="inner three"></div>
          </div>
        </div>
        <div id="pdf-btn-text" className="pdf-btn-text">PDF Options</div>
      </div>

      {showPopup && (
        <div className="pdf-popup-overlay">
          <div className="pdf-popup">
            <h3>PDF Options</h3>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ width: "100%", marginBottom: "10px" }}
              placeholder="Recipient email"
            />
            <div style={{ marginBottom: "10px" }}>
              <button
                className="popup-btn"
                onClick={() => {
                  setShowPopup(false);
                  (async () => {
                    const exists = await checkPdfExists(userData.key, auth, pdfLanguage);
                    if (exists) {
                      Axios.post(url.sendEmailPdf, { code: userData.key, email, language: pdfLanguage }, {
                        headers: {
                          "x-access-token": (() => {
                            if (!auth || auth === "null" || auth === "undefined") return null;
                            try { return auth; } catch { return null; }
                          })()
                        }
                      })
                        .then(res => {
                          alert(res.data.success ? "Email sent using existing PDF!" : "Failed to send email.");
                        })
                        .catch(() => {
                          alert("Failed to send email.");
                        });
                      return;
                    }

                    await waitForPdfRender();
                    PDFLogic(userData.key, email, pdfLanguage, "sendAndStore", auth);
                  })();
                }}
              >
                Send PDF by Email
              </button>
              <button
                className="popup-btn"
                onClick={() => {
                  setShowPopup(false);
                  (async () => {
                    const exists = await checkPdfExists(userData.key, auth, pdfLanguage);
                    if (exists) {
                      Axios.get(`${url.downloadPdf}?key=${encodeURIComponent(userData.key)}&language=${encodeURIComponent(pdfLanguage)}`, {
                        responseType: 'blob',
                        headers: {
                          "x-access-token": (() => {
                            if (!auth || auth === "null" || auth === "undefined") return null;
                            try { return auth; } catch { return null; }
                          })()
                        }
                      })
                        .then(res => {
                          const urlBlob = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                          const link = document.createElement('a');
                          link.href = urlBlob;
                          link.setAttribute('download', `Scope-Report-${userData.key}.pdf`);
                          document.body.appendChild(link);
                          link.click();
                          link.remove();
                        })
                        .catch(() => {
                          alert("Failed to download PDF.");
                        });
                      return;
                    }

                    await waitForPdfRender();
                    PDFLogic(userData.key, null, pdfLanguage, "downloadAndStore", auth);
                  })();
                }}
              >
                Download PDF
              </button>
              <button
                className="popup-btn"
                onClick={() => {
                  setShowPopup(false);
                  (async () => {
                    const exists = await checkPdfExists(userData.key, auth, pdfLanguage);
                    if (exists) {
                      window.open(`${url.downloadPdf}?key=${encodeURIComponent(userData.key)}&language=${encodeURIComponent(pdfLanguage)}`, '_blank');
                      Axios.post(url.sendEmailPdf, { code: userData.key, email, language: pdfLanguage }, {
                        headers: {
                          "x-access-token": (() => {
                            if (!auth || auth === "null" || auth === "undefined") return null;
                            try { return auth; } catch { return null; }
                          })()
                        }
                      })
                        .then(res => {
                          alert(res.data.success ? "Email sent using existing PDF!" : "Failed to send email.");
                        })
                        .catch(() => {
                          alert("Failed to send email.");
                        });
                      return;
                    }

                    await waitForPdfRender();
                    PDFLogic(userData.key, email, pdfLanguage, "downloadAndSendAndStore", auth);
                  })();
                }}
              >
                Download & Send PDF
              </button>
              <button className="popup-btn" onClick={() => setShowPopup(false)}>Cancel</button>
            </div>
            </div>
          </div>
      )}

      <Preferences user={userData} auth={auth} />
      <div id="UserInfo-header">
        <div id="UserInfo-header-content">
          <p><b>Key : </b>{userData.key}</p>
          <p><b>Date survey passed : </b>{userData.dateSurveyPassed}</p>
        </div>
      </div>
      <div>
        <div className="UserInfo-content">
          <PageChartsComponents.PageCharts
            askedfor='admin'
            dataForGraphs={userData.results}
            currentLanguage={effectiveLocale}
            email={userData.email}
            code={userData.code}
            datePassed={userData.dateSurveyPassed}
            timeTaken={userData.testDuration}
            userLanguage={userData.language}
            user={userData}
            location={{ state: userData }}
          />
        </div>
      </div>
    </div>
  );
}